export const OCR_UNLOAD_WARNING_TEXT =
	'OCR is in progress. If you reload or leave this page, the current OCR upload will be canceled.';

export const OCR_NAVIGATION_WARNING_TEXT =
	'OCR is in progress. Leaving this page or switching chatbots will cancel the current OCR upload. Do you want to continue?';

export const sendCancelOcrBeacon = (chatbotId) => {
	if (!chatbotId) return;
	const endpoint = `/api/chatbot/${encodeURIComponent(chatbotId)}/cancel_ocr`;

	try {
		if (navigator.sendBeacon) {
			const payload = new Blob(['{}'], { type: 'application/json' });
			navigator.sendBeacon(endpoint, payload);
			return;
		}
	} catch (error) {
		// Fall back to fetch keepalive below.
	}

	try {
		fetch(endpoint, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: '{}',
			keepalive: true
		}).catch(() => {});
	} catch (error) {
		// Best effort only during unload transitions.
	}
};

export const registerOcrBeforeUnloadGuard = ({ ragUploadLoadingRef }) => {
	const handleBeforeUnload = (event) => {
		if (!ragUploadLoadingRef.current) {
			return undefined;
		}

		event.preventDefault();
		event.returnValue = OCR_UNLOAD_WARNING_TEXT;
		return OCR_UNLOAD_WARNING_TEXT;
	};

	window.addEventListener('beforeunload', handleBeforeUnload);
	return () => {
		window.removeEventListener('beforeunload', handleBeforeUnload);
	};
};

export const cancelOcrOnEditorTeardown = ({
	ragUploadLoadingRef,
	selectedPromptTitleRef,
	ragUploadCancelHandlerRef
}) => {
	if (!ragUploadLoadingRef.current) {
		return;
	}

	sendCancelOcrBeacon(selectedPromptTitleRef.current);

	const cancelHandler = ragUploadCancelHandlerRef.current;
	if (typeof cancelHandler === 'function') {
		try {
			cancelHandler();
		} catch (error) {
			// Best effort only during component teardown.
		}
	}
};

export const cancelRagUploadWithHandler = async (ragUploadCancelHandler) => {
	if (typeof ragUploadCancelHandler === 'function') {
		await ragUploadCancelHandler();
	}
};

export const confirmOcrCancelBeforeLeave = async ({
	ragUploadLoadingRef,
	selectedPromptTitleRef,
	ragUploadCancelHandlerRef
}) => {
	if (!ragUploadLoadingRef.current) {
		return true;
	}

	const shouldLeave = window.confirm(OCR_NAVIGATION_WARNING_TEXT);
	if (!shouldLeave) {
		return false;
	}

	sendCancelOcrBeacon(selectedPromptTitleRef.current);
	const cancelHandler = ragUploadCancelHandlerRef.current;
	if (typeof cancelHandler === 'function') {
		try {
			await cancelHandler();
		} catch (error) {
			// Best effort cancel before navigation.
		}
	}

	return true;
};
